// src/components/ui/Alert.js
import React from 'react';

export const Alert = ({ children, className = '' }) => (
  <div className={`bg-yellow-50 border border-yellow-200 rounded-lg p-4 ${className}`}>
    {children}
  </div>
);

export const AlertDescription = ({ children }) => (
  <div className="text-sm text-gray-600">
    {children}
  </div>
);

export default Alert;